import React from 'react';
import { Price as PriceElement } from '@tvg/fuse/price';
import { Typography } from '@tvg/fuse/typography';
import { PriceProps } from './PriceProps';
import styles from './Price.module.css';

function Price({ price }: { price: PriceProps }): JSX.Element {
  const { currencySymbol, unitPrice } = price;

  const currPrice = price.currentFrom !== undefined ? Number(price.currentFrom.slice(1)) : price.unformattedPrice;
  const prevPrice = price.previousFrom !== undefined ? price.wasFromUnformatted : price.unformattedPrevious;
  const showSaving = !!price.unformattedSaving || !!price.unformattedSavingTo;
  const savingPrice = price.unformattedSavingTo || price.unformattedSaving;
  const isEuro = currencySymbol !== '£';

  return (
    <div className={styles.container}>
      <PriceElement
        id="product-price"
        dataTestId="product-price"
        headingTag="h2"
        showCurrentFrom={!!price.currentFrom}
        showPreviousFrom={!!price.previousFrom}
        price={currPrice}
        prevPrice={prevPrice}
        saving={savingPrice}
        showSave={showSaving}
        isEuro={isEuro}
      />
      {unitPrice && (
        <Typography data-testid="unit-price" type="paragraph" size="1">
          {unitPrice}
        </Typography>
      )}
    </div>
  );
}
export default Price;
